<script lang="ts">
    import {getLocalization} from 'src/core';
    import type {Sorting} from 'src/typings';
    import {pipe} from 'core/utils';
    import {loc} from 'shared/utils/pipes';
    import {createEventDispatcher} from 'svelte';
    import KpStyledSelect from 'shared/ui-widgets/select/KpStyledSelect.svelte';

    export let selectedSorting: Sorting;
    export let availableSortings: Sorting[];

    const dispatch = createEventDispatcher<{'change-sorting': Sorting}>();
    const localize = getLocalization();

    function changeSorting() {
        dispatch('change-sorting', selectedSorting);
    }
</script>

<span class="search-sorting-selector">
    <label for="search-sorting-select">{localize(/* @kp-localization hledani.razeni.SeraditVysledkyPodle */ 'hledani.razeni.SeraditVysledkyPodle')}:</label>

    <KpStyledSelect id="search-sorting-select" bind:value={selectedSorting} on:change={changeSorting}>
        {#each availableSortings as sorting (sorting.id)}
            <option value={sorting}>
                {pipe(sorting, loc())}
            </option>
        {/each}
    </KpStyledSelect>
</span>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";

    .search-sorting-selector {
        display: inline-flex;
        align-items: center;
        gap: @spacing-s;

        label {
            margin-bottom: 0;
        }
    }
</style>